var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _g, _path14, _g2, _path15, _g3, _path16, _g4, _path17, _g5, _path18, _g6, _path19, _g7, _path20, _path21, _path22, _path23, _path24, _g8, _path25, _g9, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _g10, _path41, _g11, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPhotosUploadGray = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 273 182"
}, props), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#jottacloud_PhotosUploadGray.svg__a)"
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M1.915 35.14 195.342 1.158l25.722 145.346-193.427 33.982z",
  clipRule: "evenodd"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  d: "m221.385 145.433.262 1.477-1.483.26-191.45 33.635-1.485.26-.262-1.478L1.593 36.211l-.261-1.476 1.483-.261L194.265.84l1.485-.26.261 1.477zM2.991 35.459l-.493.087.087.493L27.96 179.415l.087.491.492-.086 191.449-33.634.494-.087-.088-.493L195.019 2.23l-.087-.491-.492.086z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#B7B7B7",
  fillRule: "evenodd",
  d: "M214.087 141.637 32.521 173.535 8.891 40.007 190.456 8.11z",
  clipRule: "evenodd"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M214.087 141.637 32.521 173.535 8.891 40.007 190.456 8.11z",
  clipRule: "evenodd"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  fill: "#B5B5B5",
  fillRule: "evenodd",
  d: "M214.088 141.637 32.522 173.535l-3.294-18.618-4.174-23.58L206.62 99.44z",
  clipRule: "evenodd"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M214.088 141.637 32.522 173.535l-3.294-18.618-4.174-23.58L206.62 99.44z",
  clipRule: "evenodd"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M52.098 146.504 77.821 1.158 271.248 35.14l-25.722 145.346z",
  clipRule: "evenodd"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  d: "m271.831 34.735-.261 1.476-25.374 143.376-.262 1.478-1.486-.26L52.999 147.17l-1.484-.26.262-1.477L77.15 2.057l.261-1.478 1.485.26V.84l191.45 33.634zM52.769 145.606l-.087.493.493.087 191.449 33.634.491.086.087-.491 25.374-143.376.088-.493-.493-.087L78.722 1.825l-.492-.086-.087.491z"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  fill: "#B5B5B5",
  fillRule: "evenodd",
  d: "M240.64 173.535 59.074 141.637 82.706 8.109l181.566 31.898z",
  clipRule: "evenodd"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M240.64 173.535 59.074 141.637 82.706 8.109l181.566 31.898z",
  clipRule: "evenodd"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  fill: "#E4E4E4",
  fillRule: "evenodd",
  d: "M259.533 66.846a32.6 32.6 0 0 0-11.994-3.433c-17.947-1.564-33.769 11.663-35.338 29.544s11.706 33.645 29.652 35.209c2.328.203 4.619.152 6.849-.121z",
  clipRule: "evenodd"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M259.533 66.846a32.6 32.6 0 0 0-11.994-3.433c-17.947-1.564-33.769 11.663-35.338 29.544s11.706 33.645 29.652 35.209c2.328.203 4.619.152 6.849-.121z",
  clipRule: "evenodd"
})), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUploadGray.svg__b",
  width: 277,
  height: 216,
  x: -4,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3.011 215.41H272.41V0H-3.011z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUploadGray.svg__b)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M38.376 166.453h196.41V18.865H38.376z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUploadGray.svg__c",
  width: 277,
  height: 216,
  x: -4,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3.011 215.41H272.41V0H-3.011z"
}))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUploadGray.svg__c)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  d: "M38.88 165.452v.5h195.403V19.364H38.879v146.088ZM233.782 18.364h1.507v148.588H37.872V18.364z"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUploadGray.svg__d",
  width: 277,
  height: 216,
  x: -4,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3.011 215.41H272.41V0H-3.011z"
}))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUploadGray.svg__d)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E4E4E4",
  fillRule: "evenodd",
  d: "M44.398 99.82h184.366V24.865H44.398z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUploadGray.svg__e",
  width: 277,
  height: 216,
  x: -4,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3.011 215.41H272.41V0H-3.011z"
}))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUploadGray.svg__e)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M44.398 99.82h184.366V24.865H44.398z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUploadGray.svg__f",
  width: 277,
  height: 216,
  x: -4,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3.011 215.41H272.41V0H-3.011z"
}))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUploadGray.svg__f)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#B5B5B5",
  fillRule: "evenodd",
  d: "M44.398 117.176h184.366V99.82H44.398z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUploadGray.svg__g",
  width: 277,
  height: 216,
  x: -4,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3.011 215.41H272.41V0H-3.011z"
}))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUploadGray.svg__g)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M44.398 117.176h184.366V99.82H44.398z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUploadGray.svg__h",
  width: 277,
  height: 216,
  x: -4,
  y: 0,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M-3.011 215.41H272.41V0H-3.011z"
}))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUploadGray.svg__h)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#2C2C2C",
  fillRule: "evenodd",
  d: "M44.398 160.452h184.366v-43.277H44.398z",
  clipRule: "evenodd"
}))), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M189.512 99.82c0-7.42 6.036-13.433 13.482-13.433 7.447 0 13.484 6.014 13.484 13.433"
})), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M189.847 99.82c0-7.42 6.036-13.433 13.482-13.433s13.483 6.014 13.483 13.433z",
  clipRule: "evenodd"
})), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M189.847 99.82c0-7.42 6.036-13.433 13.482-13.433s13.483 6.014 13.483 13.433z",
  clipRule: "evenodd"
})), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M190.7 105.613h25.092m-19.07 5h13.048"
})), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUploadGray.svg__i",
  width: 55,
  height: 110,
  x: 44,
  y: 44,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.398 44.654v108.597h54.447V44.654z"
}))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUploadGray.svg__i)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M55.78 101.935c6.43 4.139 15.09 2.282 19.245-4.125l5.822-8.981c2.522-3.891 2.662-8.622.809-12.522l14.958-9.171c2.2-1.35 2.892-4.248 1.538-6.441-1.355-2.193-4.263-2.883-6.464-1.533l-16.94 10.387-.026-.016-.57.352c-.383.236-.86.263-1.266.072a1.324 1.324 0 0 1-.56-1.91l3.573-5.625.025.023 6.738-10.61c1.383-2.176.727-5.082-1.457-6.459s-5.102-.724-6.483 1.452L64.484 62.945l-14.773 24.28-51.257 47.77 19.373 18.256 46.669-49.163",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUploadGray.svg__j",
  width: 55,
  height: 110,
  x: 44,
  y: 44,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M44.398 44.654v108.597h54.447V44.654z"
}))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUploadGray.svg__j)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M55.78 101.935c6.43 4.139 15.09 2.282 19.245-4.125l5.822-8.981c2.522-3.891 2.662-8.622.809-12.522l14.958-9.171c2.2-1.35 2.892-4.248 1.538-6.441-1.355-2.193-4.263-2.883-6.464-1.533l-16.94 10.387-.026-.016-.57.352c-.383.236-.86.263-1.266.072a1.324 1.324 0 0 1-.56-1.91l3.573-5.625.025.023 6.738-10.61c1.383-2.176.727-5.082-1.457-6.459s-5.102-.724-6.483 1.452L64.484 62.945l-14.773 24.28-51.257 47.77 19.373 18.256 46.669-49.163"
}))), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M70.529 88.575c1.355 2.193 4.263 2.883 6.464 1.533l10.608-6.504c2.201-1.35 2.894-4.248 1.539-6.441-1.354-2.193-4.264-2.883-6.465-1.534l-10.608 6.505c-2.2 1.35-2.893 4.248-1.538 6.44",
  clipRule: "evenodd"
})), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M70.529 88.575c1.355 2.193 4.263 2.883 6.464 1.533l10.608-6.504c2.201-1.35 2.894-4.248 1.539-6.441-1.354-2.193-4.264-2.883-6.465-1.534l-10.608 6.505c-2.2 1.35-2.893 4.248-1.538 6.44Z",
  clipRule: "evenodd"
})), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M72.759 98.65a4.71 4.71 0 0 0 6.464 1.533l7.108-4.358a4.67 4.67 0 0 0 1.539-6.441 4.71 4.71 0 0 0-6.465-1.533l-7.108 4.358a4.67 4.67 0 0 0-1.538 6.44",
  clipRule: "evenodd"
})), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M72.759 98.65a4.71 4.71 0 0 0 6.464 1.533l7.108-4.358a4.67 4.67 0 0 0 1.539-6.441 4.71 4.71 0 0 0-6.465-1.533l-7.108 4.358a4.67 4.67 0 0 0-1.538 6.44Z",
  clipRule: "evenodd"
})), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
  fill: "#E2E1F9",
  fillRule: "evenodd",
  d: "M65.098 86.003a12.57 12.57 0 0 0-1.566-8.667z",
  clipRule: "evenodd"
})), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M65.098 86.003a12.57 12.57 0 0 0-1.566-8.667"
})), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "m60.566 97.056 14.53-3.748a5.32 5.32 0 0 0 3.96-5.688 5.33 5.33 0 0 0-5.036-4.769L62.174 82.4",
  clipRule: "evenodd"
})), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m60.566 97.056 14.53-3.748a5.32 5.32 0 0 0 3.96-5.688 5.33 5.33 0 0 0-5.036-4.769L62.174 82.4"
})), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M172.802 62.214s-7.026-19-26.706-22.01c-38.682-5.917-38.533 27.316-38.533 27.316",
  clipRule: "evenodd"
})), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M172.634 78.214v-16s-3.537-17.836-27.71-22.01c-39.035-6.74-37.529 27.316-37.529 27.316v11.694z",
  clipRule: "evenodd"
})), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M107.728 84.106c-4.065 0-7.36-3.283-7.36-7.334 0-4.05 3.295-7.334 7.36-7.334",
  clipRule: "evenodd"
})), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M107.728 84.106c-4.065 0-7.36-3.283-7.36-7.334 0-4.05 3.295-7.334 7.36-7.334"
})), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M172.633 69.439c4.064 0 7.36 3.283 7.36 7.333s-3.296 7.334-7.36 7.334",
  clipRule: "evenodd"
})), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M172.633 69.439c4.064 0 7.36 3.283 7.36 7.333s-3.296 7.334-7.36 7.334"
})), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUploadGray.svg__k",
  width: 102,
  height: 40,
  x: 90,
  y: 121,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M90.722 160.452H191.09V121.41H90.722z"
}))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUploadGray.svg__k)"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#E4E4E4",
  fillRule: "evenodd",
  d: "M191.09 214.41H90.722v-43c0-27.5 22.583-50 50.184-50s50.184 22.5 50.184 50z",
  clipRule: "evenodd"
}))), /*#__PURE__*/React.createElement("mask", {
  id: "jottacloud_PhotosUploadGray.svg__l",
  width: 102,
  height: 40,
  x: 90,
  y: 121,
  maskUnits: "userSpaceOnUse",
  style: {
    maskType: "luminance"
  }
}, _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M90.722 160.452H191.09V121.41H90.722z"
}))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
  mask: "url(#jottacloud_PhotosUploadGray.svg__l)"
}, /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M191.09 214.41H90.722v-43c0-27.5 22.583-50 50.184-50s50.184 22.5 50.184 50z",
  clipRule: "evenodd"
}))), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  fillRule: "evenodd",
  d: "M172.812 76.106v22.557c0 17.196-14.122 31.267-31.384 31.267h-2.737c-17.261 0-31.384-14.071-31.384-31.268V76.107",
  clipRule: "evenodd"
})), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M172.812 76.106v22.557c0 17.196-14.122 31.267-31.384 31.267h-2.737c-17.261 0-31.384-14.071-31.384-31.268V76.107"
})), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 2,
  d: "m141.298 79.426 4.798 14.967h-8.727"
})), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M107.307 64.41c1.983-20.75 22.211-30.07 41.467-23.202m14.213 6.702c5.801 3.554 9.403 9.066 9.825 16.5"
})), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M153.818 42.572c-4.979 8.767-18.618 13.668-27.434 10.463m33.065-7.658c-2.346 9.505-10.794 16-20.171 16.361"
})), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
  fill: "#B7B7B7",
  fillRule: "evenodd",
  d: "M152.245 104.033c0 6.705-5.455 12.14-12.185 12.14s-12.185-5.435-12.185-12.14z",
  clipRule: "evenodd"
})), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M152.245 104.033c0 6.705-5.455 12.14-12.185 12.14s-12.185-5.435-12.185-12.14z",
  clipRule: "evenodd"
})), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M117.737 76.105a8.53 8.53 0 0 1 4.656-4.08 8.59 8.59 0 0 1 9.852 2.955m32.175 1.125a8.53 8.53 0 0 0-4.656-4.08 8.59 8.59 0 0 0-9.852 2.955"
})), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
  fill: "#D8D8D8",
  fillRule: "evenodd",
  d: "M147.102 114.001a12.13 12.13 0 0 1-6.955 2.17c-3.935 0-7.428-1.85-9.646-4.72a12.06 12.06 0 0 1 6.956-2.18c3.924 0 7.417 1.85 9.645 4.73",
  clipRule: "evenodd"
})), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M147.102 114.002a12.13 12.13 0 0 1-6.955 2.17c-3.935 0-7.428-1.85-9.646-4.72m0-.001a12.06 12.06 0 0 1 6.956-2.18c3.924 0 7.417 1.85 9.645 4.73"
})), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
  stroke: "#2C2C2C",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "M44.398 160.452h184.366V24.864H44.398z",
  clipRule: "evenodd"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "jottacloud_PhotosUploadGray.svg__a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h273v182H0z"
})))));
export default SvgPhotosUploadGray;